import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Card, CardBody, Button, Spinner,
  FormGroup, Label, Input, FormFeedback, CardHeader,
} from 'reactstrap'
import DeleteRecordByAdmin from '../../components/Modal/DeleteRecordByAdmin'
import DataTable from '../../components/Template/Table/DataTable'
import Select from '../../components/Template/Input/Select'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'
import { getDepartmentTypes, getCityTypes } from '../../store/ducks/types'
import { getProjects } from '../../store/ducks/admin'

class Project extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project: {},

      addProjectModalIsOpen: false,
      addProjectIsLoading: false,

      editProjectModalIsOpen: false,
      editProjectIsLoading: false,

      deleteRecordModalIsOpen: false,
      deleteRecordId: null,
      deleteRecordName: '',
    }
  }

  componentDidMount() {
    const { getDepartmentTypes, getCityTypes, getProjects } = this.props

    getProjects()
    getDepartmentTypes()
    getCityTypes()
  }

  toggleModal = (type) => {
    const {
      addProjectIsLoading, editProjectIsLoading,
      addProjectModalIsOpen, editProjectModalIsOpen,
    } = this.state

    if (addProjectIsLoading || editProjectIsLoading) {
      return null
    }

    if (type === 'add') {
      this.setState(prevState => ({
        addProjectModalIsOpen: !prevState.addProjectModalIsOpen,
      }))

      if (addProjectModalIsOpen) this.setState({ project: null })
    } else if (type === 'edit') {
      this.setState(prevState => ({
        editProjectModalIsOpen: !prevState.editProjectModalIsOpen,
      }))

      if (editProjectModalIsOpen) this.setState({ project: null })
    }

    return null
  }

  handleAddProjectSubmit = async () => {
    const { project } = this.state

    if (!project?.proj_cod) this.setState({ project: { ...project, proj_codInvalid: true } })

    if (project?.proj_cod) {
      try {
        this.setState({ addProjectIsLoading: true })
        const res = await oikosApi.post('/?table=proj&action=insert', project, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        })
        console.tron.log('res handleAddProjectSubmit', res)
        this.setState({ addProjectIsLoading: false, addProjectModalIsOpen: false })
        notifySuccess('Registro adicionado com sucesso.')
        this.props.getProjects()
      } catch (e) {
        this.setState({ addProjectIsLoading: false })
        notifyError('Não foi possível adicionar o registro.')
        console.tron.log('Não foi possível adicionar o registro.', e)
      }
    }
  }

  handleEditProjectSubmit = async () => {}

  render() {
    const {
      project,
      addProjectModalIsOpen, addProjectIsLoading,
      editProjectModalIsOpen, editProjectIsLoading,
      deleteRecordModalIsOpen, deleteRecordId, deleteRecordName,
    } = this.state

    const {
      getCityTypesIsLoading, cityTypes,
      getDepartmentTypesIsLoading, departmentTypes,
    } = this.props.types

    const {
      getProjectsIsLoading, projects,
    } = this.props.admin

    const { user } = this.props.auth

    return (
      <>
        {addProjectModalIsOpen && (user.perm_id === 1) && (
          <>
            <Row>
              <Col>
                <h4>
                  Adicionar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('add')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Geral
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Código
                          </Label>
                          <Input
                            invalid={project?.proj_codInvalid}
                            value={project?.proj_cod}
                            onChange={e => this.setState({
                              project: {
                                ...project,
                                proj_cod: e.target.value,
                                proj_codInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col lg={9}>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            value={project?.proj_nome}
                            onChange={e => this.setState({ project: { ...project, proj_nome: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID SharePoint
                          </Label>
                          <Input
                            value={project?.IdSP}
                            onChange={e => this.setState({ project: { ...project, IdSP: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID Oikos
                          </Label>
                          <Input
                            value={project?.IdOikos}
                            onChange={e => this.setState({ project: { ...project, IdOikos: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Departamento
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getDepartmentTypesIsLoading}
                            isDisabled={getDepartmentTypesIsLoading || !departmentTypes}
                            options={departmentTypes}
                            value={departmentTypes?.filter(t => t.value === project?.IdDepartamento)}
                            onChange={e => this.setState({ project: { ...project, IdDepartamento: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município de execução
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === project?.IdLocalExecucao)}
                            onChange={e => this.setState({ project: { ...project, IdLocalExecucao: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={addProjectIsLoading}
                  onClick={() => this.handleAddProjectSubmit()}
                >
                  Enviar
                  {addProjectIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {editProjectModalIsOpen && (
          <>
            <Row>
              <Col>
                <h4>
                  Editar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('edit')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Geral
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Código
                          </Label>
                          <Input
                            invalid={project?.proj_codInvalid}
                            value={project?.proj_cod}
                            onChange={e => this.setState({
                              project: {
                                ...project,
                                proj_cod: e.target.value,
                                proj_codInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col lg={9}>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            value={project?.proj_nome}
                            onChange={e => this.setState({ project: { ...project, proj_nome: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID SharePoint
                          </Label>
                          <Input
                            value={project?.IdSP}
                            onChange={e => this.setState({ project: { ...project, IdSP: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID Oikos
                          </Label>
                          <Input
                            value={project?.IdOikos}
                            onChange={e => this.setState({ project: { ...project, IdOikos: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Departamento
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getDepartmentTypesIsLoading}
                            isDisabled={getDepartmentTypesIsLoading || !departmentTypes}
                            options={departmentTypes}
                            value={departmentTypes?.filter(t => t.value === project?.IdDepartamento)}
                            onChange={e => this.setState({ project: { ...project, IdDepartamento: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município de execução
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === project?.IdLocalExecucao)}
                            onChange={e => this.setState({ project: { ...project, IdLocalExecucao: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={editProjectIsLoading}
                  onClick={() => this.handleEditProjectSubmit()}
                >
                  Enviar
                  {editProjectIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {!addProjectModalIsOpen && !editProjectModalIsOpen && (
          <>
            <DeleteRecordByAdmin
              isOpen={deleteRecordModalIsOpen}
              recordId={deleteRecordId}
              recordType="proj"
              recordName={deleteRecordName}
              toggle={() => this.setState({
                deleteRecordModalIsOpen: !deleteRecordModalIsOpen,
              })}
            />

            <Row>
              <Col>
                <h4>
                  Lista
                </h4>
              </Col>

              {(user.perm_id === 1) && (
                <Col className="d-flex justify-content-end">
                  <Button outline color="primary" onClick={() => this.toggleModal('add')}>
                    Adicionar
                  </Button>
                </Col>
              )}
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardBody className="pb-1">
                    {getProjectsIsLoading && (
                      <Row>
                        <Col className="d-flex align-items-center justify-content-center py-3">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}

                    {!getProjectsIsLoading && projects && (
                      <DataTable
                        data={{
                          columns: [
                            {
                              label: 'ID',
                              field: 'proj_id',
                            },
                            {
                              label: 'Código',
                              field: 'proj_cod',
                            },
                            {
                              label: 'Nome',
                              field: 'proj_nome',
                            },
                            {
                              label: 'Ações',
                              field: 'actions',
                            },
                          ],
                          rows: projects.map(project => ({
                            ...project,
                            proj_id: Number(project.proj_id),
                            actions: (
                              <div>
                                <Button
                                  size="sm"
                                  color="light"
                                  onClick={() => {
                                    this.setState({ project, editProjectModalIsOpen: true })
                                  }}
                                >
                                  <i className="ri-pencil-fill" />
                                </Button>

                                <Button
                                  size="sm"
                                  color="light"
                                  className="ml-2"
                                  onClick={() => this.setState({
                                    deleteRecordModalIsOpen: true,
                                    deleteRecordId: project.proj_id,
                                    deleteRecordName: project.proj_nome,
                                  })}
                                >
                                  <i className="ri-delete-bin-6-line" />
                                </Button>
                              </div>
                            ),
                          })),
                        }}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  types: state.types,
  admin: state.admin,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getDepartmentTypes,
  getCityTypes,
  getProjects,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Project)
